//Import all your reducers here
import {combineReducers} from 'redux';
import userReducers from './userReducers';
import appReducers from './appReducers';

export default combineReducers({
    appReducer: appReducers,
    userReducer: userReducers,
});
